module.exports = __webpack_public_path__ + "img/mail_icon.ccc542f7.svg";